import React from "react";

export default function IconDateActive() {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16px">
    <g id="CalendarBlank">
        <path id="Union" fillRule="evenodd" clipRule="evenodd" d="M10.5 2V1.5C10.5 1.22386 10.7239 1 11 1C11.2761 1 11.5 1.22386 11.5 1.5V2H13C13 2 13.4142 2 13.7071 2.29289C13.7071 2.29289 14 2.58579 14 3V13C14 13 14 13.4142 13.7071 13.7071C13.7071 13.7071 13.4142 14 13 14H3C3 14 2.58579 14 2.29289 13.7071C2.29289 13.7071 2 13.4142 2 13V3C2 3 2 2.58579 2.29289 2.29289C2.29289 2.29289 2.58579 2 3 2H4.5V1.5C4.5 1.22386 4.72386 1 5 1C5.27614 1 5.5 1.22386 5.5 1.5V2H10.5ZM3 6V13H13V6H3ZM13 5H3V3H4.5V3.5C4.5 3.77614 4.72386 4 5 4C5.27614 4 5.5 3.77614 5.5 3.5V3H10.5V3.5C10.5 3.77614 10.7239 4 11 4C11.2761 4 11.5 3.77614 11.5 3.5V3H13V5Z" fill="url(#paint0_linear_344_938)"></path>
    </g>
    <defs>
        <linearGradient id="paint0_linear_344_938" x1="2.83561" y1="11.948" x2="12.265" y2="10.1765" gradientUnits="userSpaceOnUse">
            <stop stopColor="#ED1C24"></stop>
            <stop offset="0.26" stopColor="#EC281E"></stop>
            <stop offset="0.73" stopColor="#EC480E"></stop>
            <stop offset="1" stopColor="#EC5E04"></stop>
        </linearGradient>
    </defs>
</svg>
  );
}
